var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
    fill: "#E6FFFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3995 97.4841C80.3848 100.511 77.9208 102.952 74.8942 102.939C71.8675 102.924 69.4262 100.459 69.4395 97.4321C69.4528 94.4068 71.9181 91.9641 74.9448 91.9788C77.9715 91.9921 80.4142 94.4575 80.3995 97.4841Z",
    fill: "#33535F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9653 90.4389C69.984 84.1202 79.7653 83.9282 85.9373 90.1495C88.736 92.9695 93.116 88.6322 90.3173 85.8109C81.848 77.2762 67.9453 77.3255 59.628 86.0615C56.892 88.9322 61.2227 93.3202 63.9653 90.4389Z",
    fill: "#33535F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3521 64.9308C53.6855 57.7268 63.6335 53.1922 74.7735 53.1642C85.8148 53.1375 96.7028 57.0562 104.789 64.6508C107.679 67.3642 112.067 63.0348 109.168 60.3122C99.9055 51.6135 87.4815 46.9682 74.8028 47.0002C61.9828 47.0322 50.5908 52.2722 41.0135 60.5508C38.0068 63.1508 42.3615 67.5148 45.3521 64.9308Z",
    fill: "#33535F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6976 79.0682C58.2842 73.0282 66.1136 69.2456 74.3882 69.0562C82.8882 68.8629 91.0962 72.3642 97.0042 78.4349C99.7749 81.2816 104.155 76.9429 101.383 74.0962C94.3896 66.9122 84.4816 62.6629 74.4176 62.8922C64.5749 63.1176 55.0362 67.4709 48.3589 74.6883C45.6696 77.5963 49.9976 81.9869 52.6976 79.0682Z",
    fill: "#33535F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128.637 49.8187C128.637 59.108 121.108 66.6373 111.819 66.6373C102.529 66.6373 95 59.108 95 49.8187C95 40.5293 102.529 33 111.819 33C121.108 33 128.637 40.5293 128.637 49.8187Z",
    fill: "#F2575D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.081 55.8094L105.698 53.4255L116.378 42.7455L118.761 45.1295L108.081 55.8094Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.761 53.4255L116.378 55.8094L105.698 45.1295L108.081 42.7455L118.761 53.4255Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNetwork);
export default __webpack_public_path__ + "static/media/no-network.089e43f40ee719b56fa311c9d3e6e3b5.svg";
export { ForwardRef as ReactComponent };